import {Component} from '@angular/core'
import {MatCard} from '@angular/material/card'
import {SpbAccessibleLinkDirective} from '@sparbanken-syd/sparbanken-syd-theme'

@Component({
  selector: 'spb-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrl: './disclaimer.component.scss',
  imports: [
    MatCard,
    SpbAccessibleLinkDirective
  ]
})
export class DisclaimerComponent {

}
